import "./App.css";
import DialogLogout from "./components/LogoutDialogLogout";
import MyRoutes from "./router/MyRoutes";
import { UserProvider } from "@inkhunt/core";
import { useFetchMyProfile } from "@inkhunt/core";
import { ReactNode } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import LogoutDialogProvider from "./context/LogoutDialogContext";
import ImageDialogProvider from "./context/ImageDialogContext";
import ImageDialog from "./components/ImageDialog";
import ErrorBoundary from "./components/ErrorBoundary";
import { AnimatePresence, MotionConfig } from "motion/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GoogleOAuthProvider } from "@react-oauth/google";
import appTheme, { tokenStyles } from "./theme";
import { GOOGLE_OAUTH_CLIENT_ID } from "./constants/constants";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false },
  },
});

const AppProvider = ({ children }: { children: ReactNode }) => {
  useFetchMyProfile();

  return (
    // reducedMotion="user": with Reduce Motion on, motion drops transforms and keeps fades.
    <MotionConfig reducedMotion="user">
      <AnimatePresence>
        <ThemeProvider theme={appTheme}>
          <CssBaseline enableColorScheme />
          <GlobalStyles styles={tokenStyles} />
          <LogoutDialogProvider>
            <ImageDialogProvider>
              <div className="app">
                {children}
                <DialogLogout />
                <ImageDialog />
              </div>
            </ImageDialogProvider>
          </LogoutDialogProvider>
        </ThemeProvider>
      </AnimatePresence>
    </MotionConfig>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID ?? ""}>
        <QueryClientProvider client={queryClient}>
          <UserProvider>
            <AppProvider>
              <MyRoutes />
            </AppProvider>
          </UserProvider>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;
